import { invalidUrlError, validateUrl } from '../../utils/functions';
import PaperForm from '../../components/Forms/PaperForm';

const PublicationForm = ({ functionality }) => {
  const category = 'paper';
  const fields = [
    {
      name: 'title',
      label: 'Title',
      type: 'text',
      required: true,
    },
    {
      name: 'authors',
      label: 'Author(s)',
      type: 'chip',
      required: true,
    },
    {
      name: 'doi',
      label: 'DOI',
      type: 'text',
      required: true,
    },
    { name: 'venue', label: 'Publisher/Journal Name', type: 'text', required: true },
    {
      name: 'publicationType',
      label: 'Type of Publication',
      type: 'select',
      required: true,
      options: [
        { label: 'Journal Article', value: 'Journal Article' },
        { label: 'Book', value: 'Book' },
        { label: 'Conference Paper', value: 'Conference Paper' },
        { label: 'Webpage', value: 'Webpage' },
        { label: 'General Interest Article', value: 'General Interest Article' },
        { label: 'Other', value: 'Other' },
      ],
    },
    {
      name: 'publicationDate',
      label: 'Date of Publication',
      type: 'date',
      required: true,
    },
    {
      name: 'abstract',
      label: 'Abstract',
      type: 'text',
      text_area: true,
      rows: '12',
    },
    {
      name: 'url',
      label: 'Link/Access Information (URL)',
      type: 'text',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    { name: 'citationCount', label: 'Citation Count', type: 'number' },
    {
      name: 'influentialCitationCount',
      label: 'Influential Citation Count',
      type: 'number',
    },
    { name: 'referenceCount', label: 'Reference Count', type: 'number' },
    {
      name: 'tldr',
      label: 'TLDR',
      type: 'text',
      text_area: true,
    },
    {
      name: 'impactFactor',
      label: 'Impact Factor',
      type: 'number',
    },
    {
      name: 'peerReviewed',
      label: 'Peer-Reviewed',
      type: 'boolean',
      options: [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' },
      ],
      required: false,
    },
    {
      name: 'researchMethods',
      label: 'Research Methods',
      type: 'select',
      options: [
        { label: 'Qualitative', value: 'Qualitative' },
        { label: 'Quantitative', value: 'Quantitative' },
        { label: 'Experimental', value: 'Experimental' },
      ],
    },
    {
      name: 'fundingSource',
      label: 'Funding Source',
      type: 'text',
      text_area: true,
      rows: '2',
    },
  ];

  return functionality === 'add' ? (
    <PaperForm functionality="add" category={category} fields={fields} />
  ) : (
    <PaperForm functionality="edit" category={category} fields={fields} />
  );
};

export default PublicationForm;
